import * as React from 'react';
import { connect } from 'react-redux';
import { ErrorStore } from 'Redux/Actions/Models/ErrorActionModel';
import { withTranslation  } from 'react-i18next';

type DispatchedP = {
    errorStore: ErrorStore;
    t?: Function;
};

type P = {
    type: 'FLEET';
};
type S = {
    //
};
class ResponseComponent extends React.Component<P & DispatchedP, S> {
    constructor(props: P & DispatchedP) {
        super(props);
    }
    public render() {
        const { errorStore, t } = this.props;
        if (errorStore.responseSuccess.status === 200) {
            return <p className="form_field--success">{t('createFleetSuccess')}</p>;
        } else if (errorStore.responseError.status) {
            return <p className="form_field--error">{t(`errors:${errorStore.responseError.data.errorSubcode}`)}</p>;
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: any): DispatchedP {
    return {
        errorStore: state.errorStore
    };
}
export default withTranslation (['forms', 'errors', 'carDetails'])(connect(mapStateToProps)(ResponseComponent) as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/_ResponseComponent.tsx